import { printKitchenReceipts, printReceipt, openDrawer } from "../helpers/printHelper";
import router from "../router";
import { ORDER_STATUS } from "@/helpers/order/status";

export default {
  data() {
    return {
      localKitchenPrintProcessing: false
    };
  },
  methods: {
    markUpdated: function (itemIndex, reason = undefined) {
      // Check cancel_receipts setting
      const cancelReceiptsSetting = this.terminal.db_settings.find((item) => item.name === "cancel_receipts");
      const isCancelReceiptsEnabled = cancelReceiptsSetting 
        ? cancelReceiptsSetting.value === "true" 
        : true; // Default to true if setting is not found
      
      let orderCanceled = false;
      if (itemIndex !== null) {
        if (this.currentOrder.items[itemIndex]
          && this.currentOrder.items[itemIndex].printers.length > 0
          && this.currentOrder.items[itemIndex].sent_to_kitchen) {
          this.currentOrder.items[itemIndex].has_kitchen_updates = true;
        }
      } else if (itemIndex === null && reason === "order cancelled") {
        orderCanceled = true;
      }
      const doesItemHaveUpd = this.currentOrder.items[itemIndex]
        && ((this.currentOrder.items[itemIndex].has_kitchen_updates
          && this.currentOrder.items[itemIndex].void_status !== 1));
      const isItemCanceledAfterPrint = this.currentOrder.items[itemIndex]
        && this.currentOrder.items[itemIndex].has_kitchen_updates
        && this.currentOrder.items[itemIndex].sent_to_kitchen && this.currentOrder.items[itemIndex].void_status === 1;
      
      // Only print kitchen check if cancel_receipts is enabled OR if it's an order cancellation or non-canceled item update
      if (this.currentOrder.receipt_kitchen_printed && (doesItemHaveUpd || orderCanceled || (isItemCanceledAfterPrint && isCancelReceiptsEnabled))) {
        this.printKitchenCheck(reason);
      }
    },
    openDrawer: async function () {
      this.$log.debug("Open Drawer");
      try {
        await openDrawer();
      } catch (e) {
        this.$store.dispatch("errorModal/displayModalError", {
          modalId: "print-error",
          errorBody: {
            title: "Drawer error",
            info: "Please, check that you have a correct IP for printer and Qz tray is running"
          }
        });
        console.error("could not print open drawer", e);
      }
    },
    printCheck: async function () {
      const printPdf = this.terminal.db_settings.find((item) => item.name === "printer_pdf")
        && this.terminal.db_settings.find((item) => item.name === "printer_pdf")["value"] === "true";
      if (printPdf) {
        window.print();
        // Need to wait a bit for the print dialog to close before navigating
        await new Promise(resolve => setTimeout(resolve, 500));
      } else {
        this.$log.debug("printCheck");
        try {
          await printReceipt(this.currentOrder);
          this.currentOrder.locked_by = null;
          await this.getOrderSync().flush({ queue: true, trigger: "receipt_print" });
        } catch (e) {
          this.$store.dispatch("errorModal/displayModalError", {
            modalId: "print-error",
            errorBody: {
              title: "Printer error",
              info: "Please, check that you have a correct IP for printer and Qz tray is running"
            }
          });
          console.error("could not print receipt", e);
          // Don't navigate if there was an error
          return;
        }
      }
      
      // Handle navigation after print check if setting is enabled
      await this.handlePostPrintCheckNavigation();
    },
    printKitchenCheck: async function (reason = undefined) {
      if (!this.kitchenUpdatesAvailable && reason === undefined)
        return
      this.localKitchenPrintProcessing = true;
      const self = this;

      const cancelReceiptsSetting = this.terminal.db_settings.find((item) => item.name === "cancel_receipts");
      const isCancelReceiptsEnabled = cancelReceiptsSetting 
        ? cancelReceiptsSetting.value === "true" 
        : true; // Default to true if setting is not found
      
      let kItemsToPrint;
      if (reason === "order cancelled") {
        // For order cancellation, get ALL kitchen items that were sent to kitchen, regardless of void status
        kItemsToPrint = this.kitchenItemsAtCurrentOrder.filter(item => !!item.sent_to_kitchen && item.quantity > 0);
      } else {
        // For other reasons, use the normal filtering
        kItemsToPrint = this.kitchenItemsAtCurrentOrder.filter(item => ((item.void_status !== 1 || item.sent_to_kitchen) && item.quantity > 0));
      }
      
      try {
        if (isCancelReceiptsEnabled) {
          if (reason === "order cancelled") {
            // For order cancellation, we already filtered above, just mark items for updates
            kItemsToPrint.forEach(function (value) {
              const index = self.currentOrder.items.findIndex((item) => item.id === value.id);
              self.currentOrder.items[index].has_kitchen_updates = true;
            });
          } else if (reason === "qty changed" || reason === "item canceled") {
              kItemsToPrint = kItemsToPrint.filter((i) => !!i.sent_to_kitchen);
            }
        }
        let printResults = {
          errors: []
        };
        
        // Only try to print if there are items to print
        if (kItemsToPrint.length) {
          printResults = await printKitchenReceipts(this.currentOrder, kItemsToPrint, reason);
          
          // If there are any print errors
          if (printResults.errors.length) {
            // Mark receipt as not printed
            this.currentOrder.receipt_kitchen_printed = false;
            
            // Mark items as still needing updates (not sent)
            kItemsToPrint.forEach(function (value) {
              const index = self.currentOrder.items.findIndex((item) => item.id === value.id);
              if (index !== -1) {
                self.currentOrder.items[index].has_kitchen_updates = true;
                // Do NOT set sent_to_kitchen to true
              }
            });
            
            if (reason !== "order cancelled") {
              this.currentOrder.locked_by = null;
              this.getOrderSync().flush({ queue: true, trigger: "kitchen_print_error" }).catch(() => {});
            }
            this.localKitchenPrintProcessing = false;

            throw Error("could not print to kitchen...");
          } else {
            // Successful print - mark receipt as printed
            this.currentOrder.receipt_kitchen_printed = true;
            
            // Mark items as sent to kitchen and no longer needing updates
            kItemsToPrint.forEach(function (value) {
              const index = self.currentOrder.items.findIndex((item) => item.id === value.id);
              if (index !== -1) {
                self.currentOrder.items[index].has_kitchen_updates = false;
                // Only mark as sent if this is not an update (like cancellation)
                if (!reason) {
                  self.currentOrder.items[index].sent_to_kitchen = true;
                }
              }
            });
            
            if (reason !== "order cancelled") {
              this.currentOrder.locked_by = null;
              this.getOrderSync().flush({ queue: true, trigger: "kitchen_print" }).catch(() => {});
            }
          }
        } else {
          this.currentOrder.receipt_kitchen_printed = true;
          if (reason !== "order cancelled") {
            this.currentOrder.locked_by = null;
            this.getOrderSync().flush({ queue: true, trigger: "kitchen_print_no_items" }).catch(() => {});
          }
        }
        
        this.localKitchenPrintProcessing = false;
        
        // Check if we should navigate to Tables view after kitchen print
        await this.handlePostKitchenPrintNavigation(reason);
      } catch (e) {
        // this.currentOrder.receipt_kitchen_printed = false;
        this.$store.dispatch("errorModal/displayModalError", {
          modalId: "print-error",
          errorBody: {
            title: "Printer error",
            info: "Please, check that you have a correct IP for kitchen printer and Qz tray is running"
          }
        });
        this.localKitchenPrintProcessing = false;
        this.$log.debug("Could not print kitchen receipt", e);
      }
    },
    handlePostKitchenPrintNavigation: async function(reason = undefined) {
      // Only navigate if this was a regular kitchen print (not a cancellation or update)
      if (reason) {
        return;
      }
      
      try {
        // Check if kitchen_print_tables setting is enabled
        const kitchenPrintTablesSetting = this.terminal?.db_settings?.find((item) => item.name === "kitchen_print_tables");
        const isKitchenPrintTablesEnabled = kitchenPrintTablesSetting?.value === "true";
        
        if (!isKitchenPrintTablesEnabled) {
          return;
        }
        
        // Check if we're in table service mode
        const terminalMode = this.$store.getters.terminalMode;
        const isTableServiceMode = terminalMode === 'TABLE_SERVICE';
        
        if (!isTableServiceMode) {
          return;
        }
        
        // Check if we're in the Order view (not TableOrders)
        const currentRouteName = this.$route?.name;
        const isInOrderView = currentRouteName === "Order";
        
        if (!isInOrderView) {
          return;
        }
        
        // Check if we're looking at a specific order (not split bill)
        // In Order view, if there's a currentOrder with an id or local_id, it's a specific order
        const isSpecificOrder = this.currentOrder && (this.currentOrder.id || this.currentOrder.local_id);
        
        if (!isSpecificOrder) {
          return;
        }
        
        // Wait a bit to ensure sync completes before navigating
        await new Promise(resolve => setTimeout(resolve, 300));
        
        // All conditions met - navigate to Tables view
        // Unlock the order before navigating
        if (this.currentOrder && (this.currentOrder.status === ORDER_STATUS.OPEN || this.currentOrder.status === ORDER_STATUS.HOLD)) {
          this.currentOrder.locked_by = null;
          await this.getOrderSync().flush({ queue: true, trigger: "kitchen_print_navigate" });
        }

        router.push({ name: "Tables" }).catch(err => {
          console.error("Navigation error to Tables:", err);
        });
      } catch (e) {
        console.error("Error in handlePostKitchenPrintNavigation:", e);
      }
    },
    handlePostPrintCheckNavigation: async function() {
      try {
        // Check if print_check_tables setting is enabled
        const printCheckTablesSetting = this.terminal?.db_settings?.find((item) => item.name === "print_check_tables");
        const isPrintCheckTablesEnabled = printCheckTablesSetting?.value === "true";
        
        if (!isPrintCheckTablesEnabled) {
          return;
        }
        
        // Check if we're in table service mode
        const terminalMode = this.$store.getters.terminalMode;
        const isTableServiceMode = terminalMode === 'TABLE_SERVICE';
        
        if (!isTableServiceMode) {
          return;
        }
        
        // Check if we're in the Order or OrderCheckout view
        const currentRouteName = this.$route?.name;
        const isInOrderView = currentRouteName === "Order";
        const isInOrderCheckoutView = currentRouteName === "OrderCheckout";
        
        if (!isInOrderView && !isInOrderCheckoutView) {
          return;
        }
        
        // Check if we're looking at a specific order (not split bill)
        const isSpecificOrder = this.currentOrder && (this.currentOrder.id || this.currentOrder.local_id);
        
        if (!isSpecificOrder) {
          return;
        }
        
        // Wait a bit to ensure sync completes before navigating
        await new Promise(resolve => setTimeout(resolve, 300));
        
        // All conditions met - navigate to Tables view
        // Unlock the order before navigating
        if (this.currentOrder && (this.currentOrder.status === ORDER_STATUS.OPEN || this.currentOrder.status === ORDER_STATUS.HOLD)) {
          this.currentOrder.locked_by = null;
          await this.getOrderSync().flush({ queue: true, trigger: "print_check_navigate" });
        }

        router.push({ name: "Tables" }).catch(err => {
          console.error("Navigation error to Tables:", err);
        });
      } catch (e) {
        console.error("Error in handlePostPrintCheckNavigation:", e);
      }
    }
  },
  computed: {
    isKitchenPrintProcessing() {
      return this.localKitchenPrintProcessing;
    },
    kitchenItemsAtCurrentOrder () {
      const kitchenItems = this.currentOrder.items.filter(function (item) {
        // Check if the item itself has printers assigned (items get printers from products when added)
        return item.printers && item.printers.length > 0;
      });
      return kitchenItems;
    },
    kitchenUpdatesAvailable() {
      // add void_status === null check for online orders
      const isNewKitchenItemNotPrinted = this.currentOrder.items.filter((e) => (e.void_status === 0 || e.void_status === null ) && !e.sent_to_kitchen && e.printers && e.printers.length > 0).length > 0;
      const isKitchenUpdates = this.currentOrder.items.filter((e) => (e.void_status === 0 || e.void_status === null ) && e.has_kitchen_updates && e.printers && e.printers.length > 0).length > 0;
      return isKitchenUpdates || isNewKitchenItemNotPrinted;
    },
    // orderPlaced(){}
  }
};
